import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import TextFieldObject from "../../../textfield/TextFieldObject";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import UserSupplierMaterialService from "../../../../../API/orders/warehouse/material/UserSupplierMaterialService";
import SupplierMaterialTable from "../material/supplier/SupplierMaterialTable";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";

const ModalSetSupplier = ({
                              open,
                              handleClose,
                              title,
                              typeMaterial,
                              handleSubmit,
                              currentEditRowData,
                              handleModalAlert,
                              currencyMap,
                              loading
                          }) => {
    const [supplierMaterial, setSupplierMaterial] = useState([]);
    const [selectedString, setSelectedString] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const onClose = () => {
        setSupplierMaterial([])
        setSelectedString({})
        handleClose()
    }

    useEffect(() => {
        {
            open && UserSupplierMaterialService.getAllBySupplierMaterialId(currentEditRowData.supplierMaterialId)
                .then(function (response) {
                    setSupplierMaterial(response.data);
                    setSelectedString(response.data.find(el => el.id === currentEditRowData.supplierMaterialId))
                    setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
                })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
    }, [open]);

    return (
        <div>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    minWidth: `2000px`,
                }
            }}>
                <DialogTitle textAlign="center">{title}</DialogTitle>
                <DialogContent>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '1.5rem',
                            }}
                        >
                            <SupplierMaterialTable
                                data={supplierMaterial}
                                typeMaterial={typeMaterial}
                                modal={true}
                                currencyMap={currencyMap}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                selectedString={selectedString}
                                setSelectedString={setSelectedString}
                                handleModalAlert={handleModalAlert}
                            />
                        </Stack>
                    </form>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Обновить"} onClick={() => handleSubmit(selectedString?.supplier?.id, onClose)}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalSetSupplier;